import { render, staticRenderFns } from "./CardSolarModule.vue?vue&type=template&id=2b318ad8&"
import script from "./CardSolarModule.vue?vue&type=script&lang=js&"
export * from "./CardSolarModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports